import { useRouteError } from "react-router";
import { ErrorPage } from "@inductiveautomation/ws-components";

import NotFound from "./NotFound";

const Error = () => {
  const error = useRouteError();
  return <ErrorPage error={error} notFound={NotFound} />;
};

export default Error;
